import {createBackendEditor, referenceActionData} from '../../form/ComponentEditor';
import OperationListEditor from './OperationListEditor';
import {fileUpload, postData} from "../../../utils/request";
import React, {Fragment} from "react";
import isEqual from 'lodash-es/isEqual';
import Button from "../../form/Button";
import SupplyPurchaseForm from "./Elements/SupplyPurchaseForm";
import CheckBox from "../../form/CheckBox";
import {BarcodeFormatter, ProductSelect, productTooltip} from "../../../utils/formatters";
import ImportButton from "../../form/ImportButton";
import {PriceView} from "../../classes/Price";

class SupplyPurchaseEditor extends React.Component {

    state = {
        filtered: false,
        componentEditor: "SupplyPurchase",
        filter: [
            {column: "preset", value: "SupplyPurchase"},
            {column: "saved", value: 1}
        ],
        labels: {customer: "Partner"},
        actionButtons: [],
        actions: true,
        pool: {
            orderBy: {field: "displayname", direction: "ASC"},
            selection: {},
            autoSelect: false,
            labelKey: "displayname",
            optionsTemplate: ProductSelect,
            label: false,
            component: "OperationProductPoolItem",
            valueKey: "component_id",
            view: ["id","product_id","OperationList_id", "vat", "component_type", "component_id", ...PriceView("saleprice"), "saleprice", ...PriceView("listprice"), "listprice"],
            storeType: "remote",
            searchFormatter: BarcodeFormatter,
            placeholder: "Vonalkód vagy cím",
            onSourceItemUpdate: (value) => {
                value = {...value};
                value.component_type = "product";
                value.product_id = value.id;
                value.pickedqty = 1;
                return value;
            }
        }
    };

    promisedSetState = (newState) => {
        return new Promise((resolve) => {
            this.setState(newState, () => {
                resolve()
            });
        });
    }

    constructor(props) {
        super(props);
    }

    setFieldValue = (field, value) => {
        this.props.setFieldValue(field, value);
        if (field === "customer" && !isEqual(value, this.props.values.customer)) {
            this.props.setFieldValue("target", null);
        }
    }

    importFile = async (field, value) => {
        await this.props.processAction(async () => {
            try {
                const response = await fileUpload({action: this.props.componentConfig.componentname + ".import", file: value, data: this.props.values});
                if (response.msg) {
                    this.setState({message: response.msg, messageType: response.success ? "success" : "warning"});
                }
                if (response.success) {
                    this.list && this.list.refreshBackground();
                    this.form && this.form.refreshBackground();
                }
                if (response.redirect) {
                    let params = {};
                    parse_str(response.redirect.substr(1), params);
                    this.props.setContent(params.option, params);
                }
            } catch (e) {
                console.error(e);
            }
        });
    }

    formatOperationItems = (config) => {
        config.visible = this.props.values && this.props.values.seller;
        config.pageSize = 15;
        config.actions = true;
        config.paginatorRight = <ImportButton {
            ...this.props.getFieldProps("import")}
            data={this.props.values}
            disabled={!this.props.values[this.props.componentConfig.idfield]}
            componentConfig={this.props.componentConfig}
            label={false}
            name="file"
            saveChanges={this.importFile}
        />;
        return config;
    }

    getProps = () => {
        const props = {
            ...this.props,
            ...this.state,
            setFieldValue: this.setFieldValue,
        };
        props.actionButtons = [
            <Button key="4" disabled={ props.isLoading || !props.values.id } color="primary" icon={{lib: "fa", name: "truck"}} className="pull-right" onClick={ async (e) => {
                const values = props.values;
                values.autocheckup = true;
                await props.processAction(async () => {
                    const response = await postData({
                        action: 'OperationList.doAction',
                        actionname: 'create',
                        data: await referenceActionData(values, this.props.componentConfig)
                    });
                    await this.props.pristineForm(false);
                    return response;
                });
            }}>
                Bevételezés
            </Button>
        ];
        props.pool.parameters = {};
        props.pool.reqparams = {};
        if (props.values && props.values.seller) {
            props.pool.parameters.discount_type = "purchase";
            props.pool.parameters.partner = props.values.seller.partner_id;
            props.pool.parameters.OperationList_id = props.values.id;
            props.pool.parameters.seller = props.values.seller.partner_id;
            props.pool.parameters.customer = props.values.customer.partner_id;
        }
        props.pool.paginatorRight = <CheckBox onIcon={{lib: "fa", name: "box"}} offIcon={{lib: "fa", name: "box-open"}} value={1} checked={this.state.filtered} label={false} saveChanges={(field, value) => {
            this.setState({filtered: value});
        }} />;
        return props;
    }

    renderer = (componentProps) => {
        return <SupplyPurchaseForm {...componentProps} />;
    }

    render() {
        const props = this.getProps();
        return <OperationListEditor {...props} renderer={this.renderer} formatOperationItems={this.formatOperationItems} />;
    }

}

export default createBackendEditor({
    componentName: "OperationList",
    WrappedComponent: SupplyPurchaseEditor,
    editor: "SupplyPurchase",
    dirtyFlag: (values) => {
        return !parseInt(values.saved) && values.id;
    },
    props: {
        partnerType: "seller",
        componentActions: async (action, data, params, componentConfig) => {
            params.preset = "SupplyPurchase";
            data = await referenceActionData(data, componentConfig);
            return {action,data,params};
        }
    }
});